export const COOKIES = 'cookies';
